import React from 'react';
import PropTypes from 'prop-types';
import Img from '../Img';
import styles from './styles.sass';
import PressRatings from '../PressRatings';

const PressSection = ({ isAmp }) => [
  <PressRatings isAmp={isAmp} key="press-ratings" />,
  <div className={styles.pressRow} key="pressRow">
    <Img
      isAmp={isAmp}
      alt="The New York Times"
      src="https://d12xoj7p9moygp.cloudfront.net/images/press/nytimes-logo.png"
      srcSet="https://d12xoj7p9moygp.cloudfront.net/images/press/nytimes-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/press/nytimes-logo@2x.png 2x"
      width={199}
      height={28}
    />
    <Img
      isAmp={isAmp}
      alt="The Verge"
      src="https://d12xoj7p9moygp.cloudfront.net/images/press/the-verge-logo.png"
      srcSet="https://d12xoj7p9moygp.cloudfront.net/images/press/the-verge-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/press/the-verge-logo@2x.png 2x"
      width={145}
      height={25}
    />
    <Img
      isAmp={isAmp}
      alt="Nieman Lab"
      src="https://d12xoj7p9moygp.cloudfront.net/images/press/niemanlab-logo.png"
      srcSet="https://d12xoj7p9moygp.cloudfront.net/images/press/niemanlab-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/press/niemanlab-logo@2x.png 2x"
      width={149}
      height={25}
    />
    <Img
      isAmp={isAmp}
      alt="Fast Company"
      src="https://d12xoj7p9moygp.cloudfront.net/images/press/fastcompany-logo.png"
      srcSet="https://d12xoj7p9moygp.cloudfront.net/images/press/fastcompany-logo.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/press/fastcompany-logo@2x.png 2x"
      width={167}
      height={25}
    />
  </div>,
];

PressSection.propTypes = {
  isAmp: PropTypes.bool,
};

PressSection.defaultProps = {
  isAmp: false,
};

export default PressSection;
